import React, { useEffect } from 'react';
import { Text, Grid, GridItem, Box } from '@chakra-ui/react';
import Aos from 'aos';
import 'aos/dist/aos.css';

function Tools() {
  let Data = [
    [
      <svg
        viewBox="0 0 256 256"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMinYMin meet"
      >
        <path
          d="M251.172 116.594L139.4 4.828c-6.433-6.437-16.873-6.437-23.314 0l-23.21 23.21 29.443 29.443c6.842-2.312 14.688-.761 20.142 4.693 5.48 5.489 7.02 13.402 4.652 20.266l28.375 28.376c6.865-2.365 14.786-.835 20.269 4.657 7.663 7.66 7.663 20.075 0 27.74-7.665 7.666-20.08 7.666-27.749 0-5.764-5.77-7.188-14.235-4.27-21.336l-26.462-26.462-.003 69.637a19.82 19.82 0 0 1 5.188 3.71c7.663 7.66 7.663 20.076 0 27.747-7.665 7.662-20.086 7.662-27.74 0-7.663-7.671-7.663-20.086 0-27.746a19.654 19.654 0 0 1 6.421-4.281V94.196a19.378 19.378 0 0 1-6.421-4.281c-5.806-5.798-7.202-14.317-4.227-21.446L81.47 39.442l-76.64 76.635c-6.44 6.443-6.44 16.884 0 23.322l111.774 111.768c6.435 6.438 16.873 6.438 23.316 0l111.251-111.249c6.438-6.44 6.438-16.887 0-23.324"
          fill="#DE4C36"
        />
      </svg>,
      'Git',
    ],
    [
      <svg
        viewBox="0 -3.5 256 256"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMinYMin meet"
      >
        <g fill="#161614">
          <path d="M127.505 0C57.095 0 0 57.085 0 127.505c0 56.336 36.534 104.13 87.196 120.99 6.372 1.18 8.712-2.766 8.712-6.134 0-3.04-.119-13.085-.173-23.739-35.473 7.713-42.958-15.044-42.958-15.044-5.8-14.738-14.157-18.656-14.157-18.656-11.568-7.914.872-7.752.872-7.752 12.804.9 19.546 13.14 19.546 13.14 11.372 19.493 29.828 13.857 37.104 10.6 1.144-8.242 4.449-13.866 8.095-17.05-28.32-3.225-58.092-14.158-58.092-63.014 0-13.92 4.981-25.295 13.138-34.224-1.324-3.212-5.688-16.18 1.235-33.743 0 0 10.707-3.427 35.073 13.07 10.17-2.826 21.078-4.242 31.914-4.29 10.836.048 21.752 1.464 31.942 4.29 24.337-16.497 35.029-13.07 35.029-13.07 6.94 17.563 2.574 30.531 1.25 33.743 8.175 8.929 13.122 20.303 13.122 34.224 0 48.972-29.828 59.756-58.22 62.912 4.573 3.957 8.648 11.717 8.648 23.612 0 17.06-.148 30.791-.148 34.991 0 3.393 2.295 7.369 8.759 6.117 50.634-16.879 87.122-64.656 87.122-120.973C255.009 57.085 197.922 0 127.505 0" />
          <path d="M47.755 181.634c-.28.633-1.278.823-2.185.389-.925-.416-1.445-1.28-1.145-1.916.275-.652 1.273-.834 2.196-.396.927.415 1.455 1.287 1.134 1.923M54.027 187.23c-.608.564-1.797.302-2.604-.589-.834-.889-.99-2.077-.373-2.65.627-.563 1.78-.3 2.616.59.834.899.996 2.08.36 2.65M58.33 194.39c-.782.543-2.06.034-2.849-1.1-.781-1.133-.781-2.493.017-3.038.792-.545 2.05-.055 2.85 1.07.78 1.153.78 2.513-.019 3.069M65.606 202.683c-.699.77-2.187.564-3.277-.488-1.114-1.028-1.425-2.487-.724-3.258.707-.772 2.204-.555 3.302.488 1.107 1.026 1.445 2.496.7 3.258M75.01 205.483c-.307.998-1.741 1.452-3.185 1.028-1.442-.437-2.386-1.607-2.095-2.616.3-1.005 1.74-1.478 3.195-1.024 1.44.435 2.386 1.596 2.086 2.612M85.714 206.67c.036 1.052-1.189 1.924-2.705 1.943-1.525.033-2.758-.818-2.774-1.852 0-1.062 1.197-1.926 2.721-1.951 1.516-.03 2.758.815 2.758 1.86M96.228 206.267c.182 1.026-.872 2.08-2.377 2.36-1.48.27-2.85-.363-3.039-1.38-.184-1.052.89-2.105 2.367-2.378 1.508-.262 2.857.355 3.049 1.398" />
        </g>
      </svg>,
      'Github',
    ],
    [
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
      >
        <path
          fill="#0179cb"
          fill-rule="evenodd"
          clipRule="evenodd"
          d="m21.292 4.103-4.118-1.98a1.232 1.232 0 0 0-.489-.121L16.643 2h-.036a1.248 1.248 0 0 0-.862.364L7.869 9.55 4.437 6.947a.83.83 0 0 0-1.064.047L2.272 7.995A.83.83 0 0 0 2 8.607v.004c0 .225.09.451.272.616l2.976 2.715-2.976 2.715a.834.834 0 0 0 .001 1.232l1.101 1.001a.828.828 0 0 0 1.065.047l3.432-2.603 7.876 7.186a1.24 1.24 0 0 0 .764.358l.012.001c.018.002.037.002.055.003.025.001.05.002.075.001l.027-.001c.169-.006.337-.045.496-.122l4.118-1.98c.431-.207.706-.645.706-1.125V5.229c0-.481-.275-.918-.708-1.126zm-4.298 12.369-5.972-4.531 5.972-4.531v9.062z"
        />
      </svg>,
      'VS Code',
    ],
  ];

  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  return (
    <Box w={'full'}>
      <Box w={'full'} m={'auto'}>
        <Grid
          m={'auto'}
          w={'80%'}
          mt={10}
          templateColumns={{
            base: '1fr',
            sm: 'repeat(2,1fr)',
            md: 'repeat(3,1fr)',
            lg: 'repeat(5,1fr)',
          }}
          gap={6}
        >
          {Data.map((ele) => (
            <div
              className="skill__box btn btn2"
              key={ele[1]}
              data-aos="fade-up"
              data-aos-easing="ease-in"
            >
              <GridItem
                m={'auto'}
                textAlign={'center'}
                w={'140px'}
                h={'170px'}
                // bg={"#f5f7fb"}
                // borderRadius={"10px"}
                p={6}
                transition={'transform .2s'}
                _hover={{
                  // border: "2px solid",
                  // borderColor: "#335eea;",
                  transform: 'scale(1.05)',
                }}
              >
                <Box w={'90px'} m={'auto'}>
                  {ele[0]}
                </Box>
                <Text mt={3} fontSize={17} fontWeight={600}>
                  {ele[1]}
                </Text>
              </GridItem>
            </div>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}

export default Tools;
